import {
  FETCH_GENERAL_INFO,
  UPDATE_GENERAL_INFO,
  DELETE_GENERAL_INFO,
  CREATE_GENERAL_INFO
} from '../constants/ActionTypes';

const INITIAL_STATE = { general_info: [] };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_GENERAL_INFO:
      return {
        ...state,
        general_info: action.payload
      };
    case CREATE_GENERAL_INFO:
      return {
        ...state,
        general_info: [...state.general_info, action.payload]
      };
    case UPDATE_GENERAL_INFO:
      return {
        ...state,
        general_info: state.general_info.map(item =>
          item.general_info_key === action.payload.general_info_key
            ? { ...item, ...action.payload }
            : item
        )
      };
    case DELETE_GENERAL_INFO:
      return {
        ...state,
        general_info: state.general_info.filter(
          item => item.general_info_key !== action.payload
        )
      };
    default:
      return state;
  }
} 